import { RouteElement } from '@components'

import { ReactElement } from 'react'
import { Navigate, Route as V6Route, Routes as V6Routes } from 'react-router'
import { useLocalStorage } from 'react-use'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { E_INVOICING_STEP_TO_PATH } from '../../constants/eInvoicingStepPathMapping'
import { E_DOCUMENT_FILTER, E_INVOICING_ENTRY_URL } from '../../constants/filters'
import { EInvoicingSetupContextProvider } from '../../context/EInvoicingSetupContext'
import { EInvoicingSetupStep } from '../../types'
import { getEInvoicesUrl } from '../../utils'
import { StepRouter } from './elements'

export const EInvoicingSetup = (): ReactElement | null => {
  const { organization } = useUserOrganization()
  const [entryUrl] = useLocalStorage<string>(E_INVOICING_ENTRY_URL)

  if (!organization) {
    return null
  }

  const getStepPath = () => {
    let startToStep: EInvoicingSetupStep = 'EMPTY_STATE'
    const url = entryUrl ?? getEInvoicesUrl(organization)
    if (url && url.includes(E_DOCUMENT_FILTER)) {
      startToStep = 'COMPANY_INFO'
    }
    return E_INVOICING_STEP_TO_PATH[startToStep]
  }

  return (
    <EInvoicingSetupContextProvider>
      {/* No <Switch>: index and :step are mutually exclusive by definition. CompatRoute can't
          be used for the :step route: it always wraps its content in a v5 RouterRoute, which
          does its own v5 match against the full, un-stripped pathname - but this area is
          mounted under ViewContainer's non-exact /*-wildcard route (see ViewContainer.tsx),
          which strips that matched prefix before matching here. A relative path satisfies the
          outer v6 match but then fails CompatRoute's inner v5 match (needs the absolute path),
          and an absolute path fails the outer v6 match instead - neither works. Bare v6
          Route+RouteElement (no v5 layer involved) is the only combination where a single
          relative path works correctly. */}
      <V6Routes>
        <V6Route index element={<Navigate to={getStepPath()} replace />} />
        <V6Route
          path=":step/*"
          element={
            <RouteElement>
              <StepRouter />
            </RouteElement>
          }
        />
      </V6Routes>
    </EInvoicingSetupContextProvider>
  )
}
